<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Crear roles">
          <v-form>
            <v-container py-0>
              <v-layout
                class="pt-3"
                wrap>
                <v-flex
                  class="pr-10"
                  xs12
                  md6>
                  <v-text-field
                    class="pr-1"
                    label="Nombre de rol"/>
                </v-flex>
                <v-flex
                  xs10
                  ml10>
                  <v-checkbox
                    label="Puede leer"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md10>
                  <v-checkbox
                    label="Puede crear"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md10>
                  <v-checkbox
                    label="Puede actualizar"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md10>
                  <v-checkbox
                    label="Puede eliminar"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="primary"
                    round>Crear rol</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        xs12
        md4/>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  //
}
</script>
